import type { SiteConfig, MatchingProfile } from '../../../siteContentTypes.ts';
import { TextField, TextAreaField, NumberField, ImageField, ListEditor } from './fields.tsx';

export function MatchingSection({ config, update }: { config: SiteConfig; update: (patch: Partial<SiteConfig>) => void }) {
  const m = config.matching;
  const set = (patch: Partial<SiteConfig['matching']>) => update({ matching: { ...m, ...patch } });

  return (
    <div>
      <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 20 }}>Matching</h2>
      <TextField label="Titre" value={m.title} onChange={(v) => set({ title: v })} />
      <TextAreaField label="Description" value={m.description} onChange={(v) => set({ description: v })} rows={2} />
      <TextField label="Exemple de recherche" value={m.searchExample} onChange={(v) => set({ searchExample: v })} />
      <TextField label="Texte du CTA" value={m.ctaText} onChange={(v) => set({ ctaText: v })} />
      <TextField label="Lien du CTA" value={m.ctaUrl} onChange={(v) => set({ ctaUrl: v })} />

      <h3 style={{ fontSize: 14, fontWeight: 800, margin: '24px 0 10px' }}>Profils affichés dans la démo</h3>
      <ListEditor<MatchingProfile>
        items={m.profiles}
        onChange={(profiles) => set({ profiles })}
        itemLabel="un profil"
        newItem={() => ({ name: 'Nouveau profil', photo: '', experience: '', availability: '', rating: 4.8, skills: '', distance: '' })}
        renderItem={(p, patch) => (
          <>
            <TextField label="Nom" value={p.name} onChange={(v) => patch({ name: v })} />
            <ImageField label="Photo" value={p.photo} onChange={(v) => patch({ photo: v })} />
            <TextField label="Expérience" value={p.experience} onChange={(v) => patch({ experience: v })} />
            <TextField label="Compétences" value={p.skills} onChange={(v) => patch({ skills: v })} />
            <TextField label="Distance" value={p.distance} onChange={(v) => patch({ distance: v })} />
            <NumberField label="Note" value={p.rating} onChange={(v) => patch({ rating: v })} />
          </>
        )}
      />
    </div>
  );
}
